import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import ProductLoader from '@/_application/core/components/ui/loaders/product-loader';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {useInterestedProducts} from '@/framework/product';
import rangeMap from '@/lib/range-map';
import {SwiperSlide} from 'swiper/react';

const productSwiperBreakpoints = {
    320: {
        slidesPerView: 2,
    },
    480: {
        slidesPerView: 3,
    },
    640: {
        slidesPerView: 3,
    },
    768: {
        slidesPerView: 3,
    },
    1024: {
        slidesPerView: 4,
    },
    1280: {
        slidesPerView: 5,
    },
};

function ProductSuggestionSwiper() {
    const {data, isLoading} = useInterestedProducts();

    return (
        <CustomSwiper
            className="mt-2 grid! grid-cols-5!  place-items-center rounded-xl md:min-h-104"
            hasNavigation
            slidesPerView={4}
            spaceBetween={30}
            buttonPrevClassName="-left-6 opacity-60 h-11! w-11!"
            buttonNextClassName="-right-6 opacity-60 h-11! w-11!"
            breakpoints={productSwiperBreakpoints}>
            {isLoading
                ? rangeMap(6, i => (
                      <SwiperSlide key={i}>
                          <ProductLoader uniqueKey={`product-${i}`} />
                      </SwiperSlide>
                  ))
                : data?.items?.map((product: any) => {
                      return (
                          <SwiperSlide key={product?.sku} className="py-3">
                              <ProductCard product={product} key={`${product?.sku}`} />
                          </SwiperSlide>
                      );
                  })}
        </CustomSwiper>
    );
}

export default ProductSuggestionSwiper;
